module.exports = __webpack_public_path__ + "static/media/person.b3e526f7.svg";